// extracted by mini-css-extract-plugin
export default {"errorIcon":"styles__errorIcon--FVmBM"};